import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.every.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.array.reduce.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios';
import { refundRuleListUrl, newPageRefundRuleListUrl } from '@/apis/index';
import RefundTable from './refund-table';
export default {
  name: 'refund-project-detail',
  components: {
    RefundTable: RefundTable
  },
  props: {
    performanceId: {
      type: Number
    },
    isShowAllRefund: {
      type: Boolean,
      default: false
    },
    isNewPage: {
      type: Boolean
    },
    useTime: {
      type: Number
    },
    structureRefund: {
      type: Boolean
    }
  },
  data: function data() {
    return {
      showRefundTableMap: {},
      projectRefundData: []
    };
  },
  computed: {
    disabledOrderTimeTitle: function disabledOrderTimeTitle() {
      var noBatch = this.projectRefundData.every(function (item) {
        return item.orderPayTime === null;
      });
      return !this.isShowAllRefund && (noBatch || this.projectRefundData.length === 1);
    }
  },
  mounted: function mounted() {
    if (this.performanceId && this.structureRefund) {
      this.getProjectRefundRule();
    }
    if (this.isShowAllRefund) {
      window.seedAction({
        bid: 'b_movie_6c3fb93u_mv',
        cid: 'c_l1Ub4',
        evt: 'view',
        custom: {
          performance_id: this.performanceId
        }
      });
    }
  },
  methods: {
    getProjectRefundRule: function getProjectRefundRule() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var params, url, _yield$axios$post, _yield$axios$post$dat, data, tempShowRefundTableMap, newData, orderPayTimeMap, customInfo;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              params = {
                projectId: _this.performanceId,
                source: 1 // source 来源 1:项目详情页 2:订单详情页
              };

              url = _this.isNewPage ? newPageRefundRuleListUrl : refundRuleListUrl; // 初始化data
              _context.next = 5;
              return axios.post(url, params);
            case 5:
              _yield$axios$post = _context.sent;
              _yield$axios$post$dat = _yield$axios$post.data;
              data = _yield$axios$post$dat === void 0 ? [] : _yield$axios$post$dat;
              if (!data) data = [];
              tempShowRefundTableMap = {};
              newData = data.map(function (item) {
                var _item$showRefundRuleD;
                var refundRuleDetails = (_item$showRefundRuleD = item.showRefundRuleDetails) === null || _item$showRefundRuleD === void 0 ? void 0 : _item$showRefundRuleD.map(function (it) {
                  var _it$refundRules;
                  return Object.assign({}, it, {
                    showBuyTag: (_it$refundRules = it.refundRules) === null || _it$refundRules === void 0 ? void 0 : _it$refundRules.some(function (rule) {
                      return rule.currentUse;
                    })
                  });
                });
                if (item.orderBatchCanUse) {
                  tempShowRefundTableMap = _defineProperty({}, item.orderPayTime, true);
                }
                return Object.assign({}, item, {
                  showRefundRuleDetails: refundRuleDetails
                });
              });
              if (_this.isShowAllRefund) {
                orderPayTimeMap = newData.reduce(function (map, order) {
                  map[order.orderPayTime] = true;
                  return map;
                }, {});
                tempShowRefundTableMap = orderPayTimeMap;
              }
              _this.projectRefundData = newData;
              _this.showRefundTableMap = tempShowRefundTableMap;
              _context.next = 20;
              break;
            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](0);
              // 项目信息
              customInfo = {
                projectId: _this.performanceId
              };
              _this.$owlReportError('退款政策模块-获取项目详情页退票政策列表失败', _context.t0, customInfo);
            case 20:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 16]]);
      }))();
    },
    collapseRefundTale: function collapseRefundTale(key) {
      this.showRefundTableMap = Object.assign({}, this.showRefundTableMap, _defineProperty({}, key, !this.showRefundTableMap[key]));
    }
  }
};